import { get, post } from './fetch';
import { CERTA_API_URL } from 'config';
import * as tokenService from 'services/token-service';
import { ListNotificationsResponse } from 'types/api/notifications/list-notifications-response';
import { Notification } from 'types/notification';
import { Guid } from 'types/guid';
import { DismissNotificationRequest } from 'types/api/notifications/dismiss-notification-request';

export async function listNewNotifications(tenantId: Guid, username: string, certaVersion: string): Promise<Notification[]> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  var response = await get<ListNotificationsResponse>(
    CERTA_API_URL + `/notifications?certaVersion=${certaVersion}&username=${username}`, token, tenantId);
  return response.notifications;
}

export async function dismissNotification(notificationId: Guid, tenantId: Guid, username: string): Promise<void> {
  const token = await tokenService.readToken(tokenService.JWT_SESSION_TOKEN);
  await post(CERTA_API_URL + `/notifications/${notificationId}/dismiss`, {
    tenantId,
    username
  } as DismissNotificationRequest, token, tenantId);
}


// WEBPACK FOOTER //
// ./src/api/notification-api.ts